// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-make-js": () => import("/Users/duc/Documents/carousell/newPricelist/src/templates/make.js" /* webpackChunkName: "component---src-templates-make-js" */),
  "component---src-templates-pricing-js": () => import("/Users/duc/Documents/carousell/newPricelist/src/templates/pricing.js" /* webpackChunkName: "component---src-templates-pricing-js" */),
  "component---src-pages-404-js": () => import("/Users/duc/Documents/carousell/newPricelist/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/duc/Documents/carousell/newPricelist/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/duc/Documents/carousell/newPricelist/.cache/data.json")

